import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import TimeAgo from 'react-timeago'
import PropTypes from 'prop-types'

import FaComment from 'react-icons/fa/comment'
import FaBookmarkYes from 'react-icons/fa/bookmark'
import FaBookmarkNo from 'react-icons/fa/bookmark-o'
import FaTag from 'react-icons/fa/tag'



import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'
import './WorkEnvelope.css'


@autobind
class WorkEnvelope extends Component {
  render () {
    var description = this.props.description && this.props.description.length > 100
      ? this.props.description.substring(0, 100) + '...'
      : this.props.description

    var tags = this.props.tags && this.props.tags.length ? <div className='work__tags'><FaTag /> {this.props.tags.join(', ')}</div> : ''

    let studentFirstname = this.props.student && this.props.student.first_name && this.props.student.first_name.length > 1 ? this.props.student.first_name : 'Student'
    let studentDisplayName = this.props.student && this.props.student.display_name ? this.props.student.display_name : 'Student'
    let studentAvatar = this.props.student && this.props.student.avatar

    return (
      <article styleName='container'>

        {this.props.media.length && <div styleName='media' style={{ backgroundImage: `url("${this.props.media[0].thumb_url}")` }} />}

        <div styleName='body'>
          <PobbleAvatar avatar={studentAvatar} name={studentFirstname} style={{fontSize: '42px'}} styleName='avatar' />
          <h2 styleName='title'>{this.props.inSchool ? studentFirstname : this.props.title}</h2>
          <div styleName='school'>{this.props.inSchool ? this.props.year_group.title : this.props.school.title}</div>
        </div>

        {!this.props.inSchool && <div styleName='footer'>
          <div styleName='country'>
            {/*<img src='/images/search/uk.png' alt='UK flag' width='40' />*/}
            <span>{this.props.school && this.props.school.country}</span>
          </div>
          <span styleName='year'>{this.props.year_group.title}</span>
        </div>}
      </article>
    )
  }
}

WorkEnvelope.propTypes = {
  description: PropTypes.string,
  has_commented: PropTypes.bool,
  bookmarked_by_me: PropTypes.bool,
  media: PropTypes.array,
  school: PropTypes.object,
  student: PropTypes.object,
  tags: PropTypes.array,
  title: PropTypes.string,
  year_group: PropTypes.object,
  onBookmark: PropTypes.func
}

export default WorkEnvelope



// WEBPACK FOOTER //
// ./components/search/WorkEnvelope.js